<i18n lang='yml' src='../i18n/InventoryExamIndex.yml'></i18n>
<template>
  <tabs :locale="locale" :tab_objects="[{name: examTabName, path: '#', active: true}]">
    <div>
      <div class="media-list">
        <div class="inventory-filter-bar">
          <filter-bar :filter_params = filter_params :filter_path = base_path></filter-bar>
        </div>
        <div class="border-bottom d-flex">
          <p> {{ $t('info') }}</p>
          <a class="btn btn-sm btn-success ml-auto" :href="`${base_path}/inventory_report`" target="_blank">
            <font-awesome-icon :icon="['fas', 'plus']"/>
            {{ $t('view_report') }}
          </a>
        </div>
        <div class="content-block" v-for="item in inventoryListItems" :key="item.id">
          <div class="post-meta">
            <ul class="list-inline list-annotation">
              <li>
                <h5 class="container-item-name">
                  <a :href="`${base_path}/${item.id}/inventory_items`">{{ $t('exam_inventory') }} - {{item.test_id}}   - {{item.version_name}} - {{ item.name[locale] }} <span v-if="item.inter_provincial_exam"> - {{ $t('inter_provincial')}} </span></a>
                </h5>
              </li>
            </ul>
          </div>
          <div class="post-meta">
            <ul class="list-inline list-annotation">

              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('available_inventory')}}
                </span>
                {{item.received_inventory_count}}  
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('trade_associations')}}</span>
                 {{printTradeCodes(item.get_exam_program_associations)}}  
              </li>
            </ul>
          </div>
        </div>
        <div v-if="inventoryItems.length == 0">
          <div class="alert alert-warning" role="alert">
            {{ $t('no_data') }}
          </div>
        </div>
      </div>
       <pagination @items_changed="setItems" :items="inventoryItems" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
    </div> 
  </tabs>
    
</template>
<script>
import Main from '../../../../filter_bar/components/Main.vue';
import Tabs from '../../logbooks/components/TrainingProgramTabs.vue';
import Pagination from '../../../../shared/pagination/Pagination.vue';

export default {
  props: ['locale', 'filter_params', 'filter_path', 'base_path', 'inventory_items', 'pagination_limit', 'expansion_threshold'],

  components: {
    'filter-bar': Main,
    'tabs': Tabs,
    'pagination': Pagination,
  },

  data() {
    return {
      loading: false,
      error: false,
      filterParams: null,
      examTabName: this.$i18n.t('exam_tab_label'),
      inventoryItems: [],
      inventoryListItems: [],
      filterPath: null
    }
  },

  mounted() {
    this.$i18n.locale = this.locale;
    this.examTabName = this.$i18n.t('exam_tab_label');
    this.filterPath = this.base_path;
    this.filterParams = this.filter_params;
    try{
      this.inventoryItems = JSON.parse(this.inventory_items)
    }
    catch(err){
      this.error = true;
    }
  },

  methods: {
    printTradeCodes(items) {
      return items.length ? items.map(item => item.trade_code).join(', ') : "";
    },
    setItems(items) {
      this.inventoryListItems = items
    }
  }

}
</script>
